module.exports = __webpack_public_path__ + "static/screenshot-powerpoint-84c8a8cbf6c2f706d6362c6f3c4bcd04.png";